import { searchKeywords } from '../../../../modules/header/helpers';
import { GEOLOC_PARAM } from '../../../../shared/googlemap/constantes';

function addGeolocParameter(url) {
  return url && url.includes('?') ? `${url}&${GEOLOC_PARAM}` : `${url}?${GEOLOC_PARAM}`;
}

function addHashParameter(url, param) {
  if (url && param) {
    return url && url.includes('#') ? `${url}&${param}` : `${url}#${param}`;
  }
  return url;
}

function checkForFilterKeyword(searchUrl) {
  if (searchUrl) {
    let url = searchUrl;
    const urlSearchKeyword = url.slice(3);
    const vect = urlSearchKeyword.split('+');
    const keywordSize = searchUrl.match(/\b\w+\b/g).length;
    let searching = true;
    vect.forEach((str) => {
      if (searching) {
        if (searchKeywords[str] && keywordSize > 2) {
          url = addHashParameter(searchUrl, searchKeywords[str]);
          searching = false;
        }
      }
    });
    return url;
  }
  return searchUrl;
}

function isInvalidInput(suggestionValue, categoryValue) {
  return (!suggestionValue || suggestionValue.trim() === '')
    && (!categoryValue || categoryValue.trim() === '');
}

export default {
  checkForFilterKeyword,
  addHashParameter,
  addGeolocParameter,
  isInvalidInput,
};
